export default {
	page: "Page",
	of: "sur",
	itemsPerPage: "Éléments par page",
	totalItems: "Affichage de {start} à {end} sur {total} entrées",
};
